import {ConteudoRim} from "./conteudo-rim";

export class CapituloRim {
    id: number;
    posicao: number;
    descricao: string;
    novaPagina: boolean;

    conteudos: ConteudoRim[];
}